// extracted by mini-css-extract-plugin
export default {"reportContainer":"BiReportsPage_reportContainer__d0AbN"};